import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ClientService } from 'src/app/services/client.service';
import { UtilsService } from 'src/app/services/utils.service';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { NgxSpinnerService } from "ngx-spinner";

declare const $: any;
declare const google: any;

@Component({
    selector: 'app-client-add',
    templateUrl: './client-add.component.html',
    styleUrls: ['./client-add.component.css']
})
export class ClientAddComponent {
    clientForm!: FormGroup
    submitted = false

    fiscalRegimes: any[] = []
    cfdiUses: any[] = []

    constructor(private fb: FormBuilder, private apiClient: ClientService, private utils: UtilsService, private spinner: NgxSpinnerService, private router: Router) { }

    editOrigin = false
    editDestination = false
    indexOrigin: any = null
    indexDestination: any = null

    text_loading = "Espere un momento..."

    forModelDestination = {
        street: null,
        number: null,
        postal_code: null,
        cologne: null,
        municipality: null,
        stated: null
    }

    forModelOrigin = {
        street: null,
        number: null,
        postal_code: null,
        cologne: null,
        municipality: null,
        stated: null
    }

    formModelData: any = {
        name: null,
        rfc: null,
        postal_code: null,
        fiscal_regime_id: '',
        cfdi_use_id: '',
        business_name: null,
        is_fiscal_address: false,
        fiscal_address: null,
        street: null,
        cologne: null,
        locality: null,
        municipality: null,
        state: null,
        country: null,
        exterior_number: null,
        interior_number: null,
        email: null,
        destination_address: [],
        origin_address: []
    }

    options_autocomple = {
        fields: ["address_components", "formatted_address", "geometry", "icon", "name"],
        strictBounds: false
    };

    geocoder: any;

    cologneAddressDestination: any = [];
    cologneAddressOrigin: any = [];

    private getAddressComponent(components: any[], type: string): string {
        if (!Array.isArray(components)) return ''
        const found = components.find((c: any) => Array.isArray(c?.types) && c.types.includes(type))
        return found?.long_name || ''
    }

    onFiscalPlaceChanged(place: any) {
        const components = place?.address_components || []

        const route = this.getAddressComponent(components, 'route')
        const streetNumber = this.getAddressComponent(components, 'street_number')
        const subpremise = this.getAddressComponent(components, 'subpremise')

        const neighborhood = this.getAddressComponent(components, 'neighborhood')
        const sublocalityLevel1 = this.getAddressComponent(components, 'sublocality_level_1')
        const sublocality = this.getAddressComponent(components, 'sublocality')

        const locality = this.getAddressComponent(components, 'locality')
        const municipalityLevel2 = this.getAddressComponent(components, 'administrative_area_level_2')
        const municipalityLevel3 = this.getAddressComponent(components, 'administrative_area_level_3')
        const postalTown = this.getAddressComponent(components, 'postal_town')
        const municipality = municipalityLevel2 || municipalityLevel3 || postalTown || locality
        const state = this.getAddressComponent(components, 'administrative_area_level_1')
        const postalCode = this.getAddressComponent(components, 'postal_code')
        const country = this.getAddressComponent(components, 'country')

        const street = route
        const cologne = neighborhood || sublocalityLevel1 || sublocality

        this.formModelData.street = street || this.formModelData.street
        this.formModelData.exterior_number = streetNumber || this.formModelData.exterior_number
        this.formModelData.interior_number = subpremise || this.formModelData.interior_number
        this.formModelData.cologne = cologne || this.formModelData.cologne
        this.formModelData.locality = locality || this.formModelData.locality
        this.formModelData.municipality = municipality || this.formModelData.municipality
        this.formModelData.state = state || this.formModelData.state
        this.formModelData.postal_code = postalCode || this.formModelData.postal_code
        this.formModelData.country = country || this.formModelData.country

        if (this.clientForm) {
            this.clientForm.patchValue({
                street: this.formModelData.street || '',
                exterior_number: this.formModelData.exterior_number || '',
                interior_number: this.formModelData.interior_number || '',
                cologne: this.formModelData.cologne || '',
                locality: this.formModelData.locality || '',
                municipality: this.formModelData.municipality || '',
                state: this.formModelData.state || '',
                postal_code: this.formModelData.postal_code || '',
                country: this.formModelData.country || ''
            })
        }
    }

    ngOnInit(): void {
        this.clientForm = this.fb.group({
            name: ['', Validators.required],
            rfc: ['', Validators.required],
            fiscal_regime_id: ['', Validators.required],
            cfdi_use_id: ['', Validators.required],
            business_name: ['', Validators.required],
            is_fiscal_address: [false, Validators.required],
            fiscal_address: [''],
            street: [''],
            cologne: [''],
            locality: [''],
            municipality: [''],
            state: [''],
            postal_code: [''],
            country: [''],
            exterior_number: [''],
            interior_number: [''],
            email: ['', [Validators.required, Validators.email]]
        })

        this.loadCatalogs()

        this.clientForm.get('is_fiscal_address')?.valueChanges.subscribe((value: any) => {
            this.updateFiscalValidators(!!value)
        })
        this.updateFiscalValidators(false)
    }

    loadCatalogs() {
        this.apiClient.getFiscalRegimes().subscribe((resp: any) => {
            this.fiscalRegimes = resp || []
        })
        this.apiClient.getCfdiUses().subscribe((resp: any) => {
            this.cfdiUses = resp || []
        })
    }

    updateFiscalValidators(isFiscalAddress: boolean) {
        const fiscalAddress = this.clientForm.get('fiscal_address')
        const street = this.clientForm.get('street')
        const cologne = this.clientForm.get('cologne')
        const locality = this.clientForm.get('locality')
        const municipality = this.clientForm.get('municipality')
        const state = this.clientForm.get('state')
        const postalCode = this.clientForm.get('postal_code')
        const country = this.clientForm.get('country')
        const exteriorNumber = this.clientForm.get('exterior_number')
        const interiorNumber = this.clientForm.get('interior_number')

        if (isFiscalAddress) {
            fiscalAddress?.clearValidators()

            street?.clearValidators()
            cologne?.clearValidators()
            locality?.clearValidators()
            municipality?.clearValidators()
            state?.clearValidators()
            postalCode?.clearValidators()
            country?.clearValidators()
            exteriorNumber?.clearValidators()
            interiorNumber?.clearValidators()
        } else {
            fiscalAddress?.clearValidators()

            street?.setValidators([Validators.required])
            cologne?.setValidators([Validators.required])
            locality?.setValidators([Validators.required])
            municipality?.setValidators([Validators.required])
            state?.setValidators([Validators.required])
            postalCode?.setValidators([Validators.required])
            country?.setValidators([Validators.required])
            exteriorNumber?.setValidators([Validators.required])
            interiorNumber?.setValidators([Validators.required])
        }

        fiscalAddress?.updateValueAndValidity()
        street?.updateValueAndValidity()
        cologne?.updateValueAndValidity()
        locality?.updateValueAndValidity()
        municipality?.updateValueAndValidity()
        state?.updateValueAndValidity()
        postalCode?.updateValueAndValidity()
        country?.updateValueAndValidity()
        exteriorNumber?.updateValueAndValidity()
        interiorNumber?.updateValueAndValidity()
    }

    cologneSelected: any = {};

    keyword = 'name';


    selectEvent(item: any, type: any) {

    }

    onChangeSearch(val: any, type: any) {
        val = val.target.value

        this.geocoder = new google.maps.Geocoder();
        if (val.length >= 3) {
            this.spinner.show()
            this.text_loading = "Validando codigo postal"
                this.geocoder.geocode( { 'address': val}, (result:any, status:any) => {
                    this.spinner.hide()
                    if(status == 'OK'){

                        if (type == 2) {
                            this.forModelOrigin.cologne  = result[0].hasOwnProperty('postcode_localities') ? result[0].postcode_localities[0] : ''
                            this.forModelOrigin.municipality = result[0].address_components[1].long_name
                            this.forModelOrigin.stated = result[0].address_components[2].long_name
                        } else if (type == 3) {
                            this.forModelDestination.cologne  = result[0].hasOwnProperty('postcode_localities') ? result[0].postcode_localities[0] : ''
                            this.forModelDestination.municipality = result[0].address_components[1].long_name
                            this.forModelDestination.stated = result[0].address_components[2].long_name
                        }

                    }else{
                        alert("Ingrese un codigo postal valido")
                    }

                    
                });
            // this.apiClient.getPostal(val).subscribe((resp: any) => {
            //     if (resp.length > 0) {
            //         this.colognes = resp[0]
            //         if (type == 2) {
            //             this.cologneAddressOrigin = this.colognes.data
            //             this.forModelOrigin.stated = this.cologneAddressOrigin[0].stated
            //         } else if (type == 3) {
            //             this.cologneAddressDestination = this.colognes.data
            //             this.forModelDestination.stated = this.cologneAddressDestination[0].stated
            //         }
            //     } else {
            //         alert("Ingrese un codigo postal valido")
            //     }
            //     this.spinner.hide()
            // })
        }
    }

    onFocused(e: any) {
        // do something when input is focused
    }

    colognes: any = []

    postalCodeChanged(event: any, type: number) {

    }

    get registerFormControl() {
        return this.clientForm.controls;
    }

    addAddressDestination() {
        if (this.editDestination) {
            this.formModelData.destination_address[this.indexDestination] = this.forModelDestination
        } else {
            this.formModelData.destination_address.push(this.forModelDestination)
        }

        $("#formDestination")[0].reset()
        this.resetForm();
        $("#addAddresDestination").modal("hide")
        this.editDestination = false
        this.cologneAddressDestination = []
    }
    editAddressDestination(index: number) {
        this.forModelDestination = this.formModelData.destination_address[index]
        this.editDestination = true
        this.indexDestination = index
        this.onChangeSearch({ target: { value: this.forModelDestination.postal_code } }, 3)
        $("#addAddresDestination").modal("show")
    }
    deleteAddressDestination(i: number) {
        this.formModelData.destination_address.splice(i, 1)
    }
    resetForm() {
        this.forModelDestination = {
            street: null,
            number: null,
            postal_code: null,
            cologne: null,
            municipality: null,
            stated: null
        }

        this.forModelOrigin = {
            street: null,
            number: null,
            postal_code: null,
            cologne: null,
            municipality: null,
            stated: null
        }
    }
    resetAllForm() {
        this.formModelData = {
            name: null,
            rfc: null,
            postal_code: null,
            fiscal_regime_id: '',
            cfdi_use_id: '',
            business_name: null,
            is_fiscal_address: false,
            fiscal_address: null,
            street: null,
            cologne: null,
            locality: null,
            municipality: null,
            state: null,
            country: null,
            exterior_number: null,
            interior_number: null,
            email: null,
            destination_address: [],
            origin_address: []
        }
    }

    addAddressOrigin() {
        if (this.editOrigin) {
            this.formModelData.origin_address[this.indexOrigin] = this.forModelOrigin
        } else {
            this.formModelData.origin_address.push(this.forModelOrigin)
        }

        $("#formAddOrigin")[0].reset()
        this.resetForm();
        $("#addAddresOrigin").modal("hide")
        this.editOrigin = false
        this.cologneAddressOrigin = []
    }
    editAddressOrigin(index: number) {
        this.forModelOrigin = this.formModelData.origin_address[index]
        this.indexOrigin = index
        this.editOrigin = true
        this.onChangeSearch({ target: { value: this.forModelOrigin.postal_code } }, 2)
        $("#addAddresOrigin").modal("show")

    }
    deleteAddressOrigin(i: number) {
        this.formModelData.origin_address.splice(i, 1)
        this.resetForm()
    }
    addClient() {
        if (this.clientForm.valid) {
            this.text_loading = "Almacenando Información..."
            this.spinner.show()
            this.apiClient.addClient(this.formModelData).subscribe((resp) => {
                this.spinner.hide()
                this.utils.alertSwal({ text: "El cliente se ha registrado de forma exitosa.", icon: "success", title: "Registro Exitoso." })
                    .then(() => this.router.navigate(['/client/list']))
            }, (error) => {
                this.utils.alertSwal({ text: "Se ha presentado un error al registra el cliente.", icon: "success", title: "Error." })
                this.spinner.hide()
            })
        }
    }
}
